import { FC, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import testId from '@functions/testId';
import TextField from '@components/TextField/TextField';
/*DEBT: Makes experience appear slower, remove this and related states (verifying, setVerifying)
and dependencies (in onSubmitRecaptchaVerification)*/
import LoadingSpinner from '@components/LoadingSpinner/LoadingSpinner';
import Select from '@components/Select/Select';
import Error from '@components/InputError/InputError';
import formSources from '@functions/formSources/formSources';
import countries from '@variables/countries';
import { omni_id } from '@variables/zapierWebhookIds';
//DEBT: Refactor to remove need for (verifying, setVerifying)
import onSubmitRecaptchaVerification from '@functions/onSubmitRecaptchaVerification/onSubmitRecaptchaVerification';
import RecaptchaErrorMessage from '@components/RecaptchaErrorMessage/RecaptchaErrorMessage';
import { email } from '@variables/regexExpressions';
import submitToZapier from '@functions/submitToZapier';
import submissionData from '@functions/submissionData/submissionData';
import cx from 'classnames';
import { excludePeriods } from '@variables/regexExpressions';

declare let sw;

type Props = {
    fieldPrefix?: string;
};

const SubscribeForm: FC<Props> = ({ fieldPrefix = 'sub' }) => {
    const [submitted, setSubmitted] = useState(false);

    const [verifying, setVerifying] = useState(false);

    const [recaptchaError, setRecaptchaError] = useState(false);

    useEffect(() => {
        if (submitted === true) {
            window.location.href = '/thank-you-tb-blog-subscription/';
        }
    }, [submitted]);

    const urlParams = new URLSearchParams(window.location.search);

    const sourcingInfo = formSources({
        secondarySource: 'D - Get Started',
        pageSource: window.formInfo,
        urlParams,
        paramKeys: [
            { urlKey: 'subid', salesforceKey: 'aclid' },
            'aclid',
            'transaction_id',
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'page_url',
        ],
    });

    const {
        handleSubmit,
        register,
        formState: { errors },
        control,
    } = useForm({ mode: 'onChange' });

    const onSubmit = async (data) => {
        if (typeof sw !== 'undefined' && window['environment']['name'] === 'production') {
            sw('send-form-submit', { email: data.sub_email });
        }

        data.form_name = 'Blog Subscriber Form';

        data.status = 'Prospect';

        data.get_tier = '00GU00000035VWdMAM';

        const combinedData = { ...submissionData({ data, prefix: fieldPrefix }), ...sourcingInfo };

        const submissionFunction = () =>
            submitToZapier({
                zapierId: omni_id,
                data: combinedData,
                setSubmitted: setSubmitted,
            });

        await onSubmitRecaptchaVerification({ setVerifying, setRecaptchaError, successFunction: submissionFunction });
    };

    return (
        <form
            className={cx('form--subscribe form--touchbistro-form tw-relative tw-py-4')}
            data-testid={testId('form--subscribe')}
            onSubmit={handleSubmit(onSubmit)}
        >
            <LoadingSpinner verifying={verifying} background={'tw-bg-navy-100/70'} />
            <div className="tw-container">
                <div
                    className={cx(
                        '-tw-mx-3 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-@container/subscriber-series'
                    )}
                >
                    <div
                        className={cx(
                            'tw-align-start tw-relative tw-mb-4 tw-flex tw-w-full tw-px-3 @lg/subscriber-series:tw-w-1/4'
                        )}
                    >
                        <div className="tw-w-full [&_.text-field-label]:tw-hidden lg:[&_.text-field-label]:tw-block lg:[&_.text-field-label]:tw-text-white">
                            <TextField
                                type={'text'}
                                placeholder={'First Name'}
                                label={'First Name'}
                                testId={`${fieldPrefix}-first-name`}
                                register={{
                                    ...register(`${fieldPrefix}_first_name`, {
                                        required: true,
                                        minLength: 1,
                                        pattern: {
                                            value: excludePeriods,
                                            message: 'Invalid First Name',
                                        },
                                    }),
                                }}
                            />
                            {errors[`${fieldPrefix}_first_name`] && <Error />}
                        </div>
                    </div>

                    <div
                        className={cx(
                            'tw-align-start tw-relative tw-mb-4 tw-flex tw-w-full tw-px-3 @lg/subscriber-series:tw-w-1/4'
                        )}
                    >
                        <div
                            className={cx(
                                'tw-w-full [&_.text-field-label]:tw-hidden lg:[&_.text-field-label]:tw-block lg:[&_.text-field-label]:tw-text-white'
                            )}
                        >
                            <TextField
                                type={'email'}
                                placeholder={'Email'}
                                label={'Email'}
                                testId={`${fieldPrefix}-email`}
                                register={{
                                    ...register(`${fieldPrefix}_email`, {
                                        required: 'Email is required',
                                        pattern: email,
                                    }),
                                }}
                            />
                            {errors[`${fieldPrefix}_email`] && <Error />}
                        </div>
                    </div>
                    <div
                        className={cx(
                            'tw-align-start tw-relative tw-mb-4 tw-flex tw-w-full tw-px-3 @lg/subscriber-series:tw-w-1/4'
                        )}
                    >
                        <div
                            className={cx(
                                'tw-w-full [&_.text-field-label]:tw-hidden lg:[&_.text-field-label]:tw-block lg:[&_.text-field-label]:tw-text-white'
                            )}
                        >
                            <Controller
                                name={`${fieldPrefix}_country`}
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => {
                                    const { ref, ...relevantField } = field;
                                    return (
                                        <Select
                                            label={'Country'}
                                            placeholder={'Country'}
                                            testId={`${fieldPrefix}-country`}
                                            menuPlacement={'top'}
                                            {...relevantField}
                                            options={countries.map((country) => ({
                                                value: country,
                                                label: country,
                                            }))}
                                        />
                                    );
                                }}
                            />
                            {errors[`${fieldPrefix}_country`] && <Error />}
                        </div>
                    </div>
                    <div
                        className={cx(
                            'tw-mb-1/4 tw-mb-4 tw-flex tw-w-full tw-items-start tw-px-3 @lg/subscriber-series:tw-w-1/4'
                        )}
                    >
                        <div className="tw-h-fit tw-w-full lg:tw-mt-[calc(18px+0.375rem)]">
                            <input
                                type="submit"
                                className={`button button--form icon--chevron !tw-h-12 tw-w-full !tw-border-coral-600 !tw-bg-coral-600 hover:!tw-border-coral-800 hover:!tw-bg-coral-800
                                `}
                                value="Subscribe"
                                data-testid={testId(`${fieldPrefix}-submit`)}
                            />
                            {recaptchaError === true && <RecaptchaErrorMessage />}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default SubscribeForm;
